<template>
  <div class="header-wrapper">
    <div class="header-left">
      <img class="logo" :src="logoImageUrl" alt="logo" v-if="logoImageUrl" style="width:80%; height:100%" />
      <a :href="adminMobileUrl" target="view_window" v-else>{{ title }}</a>
    </div>
    <div class="header-right">
      <div class="role-name">{{ roleName }}</div>
      <!-- 项目 / 角色 下拉（若有其它项目或角色则显示） -->
      <div class="project-tabs-scroll-shell"
        v-show="otherProjectsList && otherProjectsList.length && permissionId === 0">
        <button v-show="canScrollProjectTabsLeft" type="button"
          class="project-tabs-scroll-button project-tabs-scroll-button--left" title="向左滚动" aria-label="向左滚动项目导航"
          @click="scrollProjectTabs(-1)">
          <i class="el-icon-arrow-left"></i>
        </button>
        <div ref="projectTabsScroll" class="project-tabs-container" @scroll="refreshProjectTabsScrollState">
          <el-dropdown v-for="project in otherProjectsList" :key="project.projectName" class="project-tab"
            :hide-on-click="Number(project.project) !== 0">
            <div class="project-tab-title">
              <span class="project-name">{{ project.projectName }}</span>
              <span v-if="project.project == 0">({{ teamAdminCount }})</span>
              <i class="el-icon-arrow-down project-arrow"></i>
            </div>
            <template slot="dropdown">
              <!-- 关键点：弹层能力来自 el-dropdown-menu（内部用 vue-popper 定位）。
                 project.project==0 也要包在 el-dropdown-menu 里，否则会以内联方式渲染。 -->
              <el-dropdown-menu v-if="Number(project.project) === 0"
                class="project-dropdown-menu project-dropdown-menu--menu">
                <!-- ElDropdownMenu 的根节点是 <ul>，这里用 li 做一个容器再放 el-menu（保持你要的 el-menu 组件） -->
                <li class="el-dropdown-menu__item project-dropdown-menu__wrap">
                  <el-menu class="project-role-menu">
                    <RoleMenuItem v-for="role in project.roles"
                      :key="`${role.roleId ?? ''}-${role.adminId ?? ''}-${role.adminName ?? ''}`" :role="role"
                      :navigate="navigateToRole" />
                  </el-menu>
                </li>
              </el-dropdown-menu>

              <el-dropdown-menu v-else class="project-dropdown-menu">
                <el-dropdown-item v-for="(role, roleIndex) in project.roles" :key="role.roleId"
                  :divided="roleIndex == 0 ? false : true">
                  <span @click="!role.isLoginIn && navigateToRole(role.pcSiteUrl, role)" class="role-item"
                    :class="{ 'disabled-role': role.isLoginIn }">
                    <i class="el-icon-user role-item-icon"></i>
                    {{ role.roleName }}
                    <el-tag v-if="role.isLoginIn" size="mini" type="success" class="current-role-tag">当前</el-tag>
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <button v-show="canScrollProjectTabsRight" type="button"
          class="project-tabs-scroll-button project-tabs-scroll-button--right" title="向右滚动" aria-label="向右滚动项目导航"
          @click="scrollProjectTabs(1)">
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="我的待阅读消息" placement="bottom" v-if="permissionId === 0">
          <span class="btn-collect" @click="addTab" v-if="permissionId === 0">
            <i :style="{
              fontSize: '16px',
              marginRight:
                waitReadingCount > 9 ? (waitReadingCount > 99 ? '13px' : '8px') : '0',
            }" class="el-icon-bell"></i>
            <span v-if="waitReadingCount >= 0" :style="{
              right:
                waitReadingCount > 9 ? (waitReadingCount > 99 ? '4px' : '8px') : '6px',
            }" class="waitReadingCount student_tag_red">{{ waitReadingCount > 99 ? "+99" : waitReadingCount }}</span>
          </span>
        </el-tooltip>
        <!-- <span class="btn-collect" @click="collectClick">
          <i class="el-icon-star-off"></i>收藏
        </span> -->
        <div class="custom-dropdown btn-collect" v-if="permissionId === 0">
          <span class="el-dropdown-link" @click="clientClick">
            <i class="el-icon-monitor"></i>客户端
          </span>
        </div>
        <el-dropdown class="custom-dropdown">
          <span class="el-dropdown-link">
            <img v-if="adminLogo" class="user-logo" :src="adminLogo" alt="" />
            <i v-else class="el-icon-user"></i>
            {{ adminName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom-dropdown-list">
            <el-dropdown-item v-if="permissionId === 0">
              <div @click="setPassWord"><i class="el-icon-lock"></i>修改登录密码</div>
            </el-dropdown-item>
            <!-- <el-dropdown-item divided>
              <div @click="dataSet"><i class="el-icon-setting"></i>资料设置</div>
            </el-dropdown-item> -->
            <el-dropdown-item :divided="true">
              <div @click="handleWechatDropdown">
                <i class="el-icon-chat-round"></i>
                <span v-if="wechatCount === 0">绑定微信号</span>
                <span v-else-if="wechatCount === 1">
                  <span :title="wechatNumber"
                    style="max-width: 110px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom;">
                    {{ wechatNumber && wechatNumber.length > 8 ? '微信号:' + (wechatNumber.slice(0, 8) + '...') : '微信号:' +
                      wechatNumber }}
                  </span>
                </span>
                <span v-else>
                  <span style="color: #409EFF">{{ wechatCount }}个微信号</span>
                </span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item :divided="permissionId === 0">
              <span class="item-btn" @click="logoutClick"><i class="el-icon-switch-button"></i>安全退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 资料设置表单 -->
    <el-dialog v-dialogDrag top="18vh" title="资料设置" :visible.sync="dialogVisible" v-if="dialogVisible"
      :close-on-click-modal="false" width="30%">
      <basic-info v-if="dialogVisible" :userInfoData="userInfoData" :add-type-list="addTypeList" type="first"
        @close-dialog="closeDialog">
      </basic-info>
    </el-dialog>
    <!-- 密码设置表单 -->
    <el-dialog v-dialogDrag top="18vh" title="修改密码" :visible.sync="passwordDialogVisible" v-if="passwordDialogVisible"
      :close-on-click-modal="false" width="30%">
      <basic-info v-if="passwordDialogVisible" :userInfoData="userInfoData" type="second" :add-type-list="addTypeList"
        @close-dialog="closeDialog">
      </basic-info>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisibleImg" v-if="dialogVisibleImg"
      :close-on-click-modal="false" width="560px" v-dialogDrag top="18vh" class="dialogprop">
      <div class="img" v-if="dialogVisibleImg" v-loading="loading">
        <img v-if="codeImg" :src="codeImg" />
        <div v-else>未设置</div>
        <p v-if="isAdmin" class="red">
          使用微信扫一扫关注，关注成功后微信将收到【当前登录账号】的所有微信提醒消息
        </p>
      </div>
    </el-dialog>
    <el-dialog title="微信号列表" class="header-wechat-table-dialog" :visible.sync="dialogVisibleWeichat"
      v-if="dialogVisibleWeichat" width="950px" :close-on-click-modal="false" v-dialogDrag :before-close="beforeClose">
      <div class="wechat-table-toolbar">
        <el-button class="wechat-add-btn" type="primary" icon="el-icon-plus" @click="addWechat">
          添加微信号
        </el-button>
      </div>
      <TableHeader :distributionIsShow="false" :empty-text="emptyText" :table-loading="tableLoading"
        :element-loading-text="loadingText" :header-data="weichatHeaderData" :table-data="weichatTableData">
        <template v-slot:isEnterprisecustom="scope">
          <el-tag v-if="scope.scope.isEnterprise" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
        <template v-slot:isOpencustom="scope">
          <el-tag v-if="scope.scope.isOpen" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
        <template v-slot:isAutoAddFriendcustom="scope">
          <el-tag v-if="scope.scope.isAutoAddFriend" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
        <template v-slot:personalAssistantTypecustom="scope">
          <el-tag :type="getPersonalAssistantTypeTagType(scope.scope.personalAssistantType)">
            {{ getPersonalAssistantTypeText(scope.scope.personalAssistantType) }}
          </el-tag>
        </template>
        <template v-slot:operatecustom="scope">
          <el-button icon="el-icon-edit" size="mini" type="primary" @click="openEditWechat(scope.scope)">编辑</el-button>
        </template>
      </TableHeader>
    </el-dialog>
    <el-dialog title="编辑微信号" class="wechatEdit" :visible.sync="dialogVisibleEditWeichat" v-if="dialogVisibleEditWeichat"
      width="680px" top="3vh" :close-on-click-modal="false" v-dialogDrag>
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="微信号" prop="number">
          <el-input style="width: 250px" placeholder="请输入微信号" v-model="form.number" :maxlength="50"></el-input>
        </el-form-item>
        <!-- <el-form-item label="微信Id">
          <el-input style="width: 250px;" placeholder="请输入微信Id" v-model="form.weiXinId"></el-input>
        </el-form-item> -->
        <el-form-item label="是否企业微信" prop="isEnterprise">
          <el-switch active-text="是" inactive-text="否" v-model="form.isEnterprise"></el-switch>
        </el-form-item>
        <el-form-item label="是否启用" prop="isOpen">
          <el-switch active-text="是" inactive-text="否" v-model="form.isOpen"></el-switch>
        </el-form-item>
        <el-form-item label="自动加好友" prop="isAutoAddFriend">
          <div class="wechat-auto-add-field">
            <el-switch active-text="是" inactive-text="否" v-model="form.isAutoAddFriend"
              @change="handleAutoAddFriendChange"></el-switch>
            <span class="wechat-auto-add-tip red">注：分配接入学员成功后：如果老师未加当前学员为好友时，系统将自动通过被分配学员的微信号，将其加为老师的微信好友；一个老师有且只能将[一个微信号]设置为自动加好友</span>
          </div>
        </el-form-item>
        <el-form-item label="个微助手" prop="personalAssistantType">
          <el-radio-group v-model="form.personalAssistantType" class="personal-assistant-options">
            <el-radio v-for="item in personalAssistantTypeOptions" :key="item.key" :label="item.key">
              {{ item.value }}
            </el-radio>
          </el-radio-group>
          <span class="personal-assistant-tip red">注：如需开启个微助手:慧航业务的老师请选择[开启--小助手平台(慧航)],学历业务的老师请选择[开启--FlowBot机器人平台(学历)]</span>
        </el-form-item>
      </el-form>
      <div class="button">
        <el-button :loading="isLoading" :disabled="isLoading" type="primary" @click="editSubmitWechat">提交保存</el-button>
        <el-button @click="dialogVisibleEditWeichat = false">取消</el-button>
      </div>
    </el-dialog>
    <AddWechat ref="addWechat" :isLoading="isLoading2" :dialogVisible="dialogVisibleAddWeichat"
      :disableAdminChange="true" :hasAutoAddFriend="hasAutoAddFriendWechat" @closeDialog="closeDialog1"
      @submitWechat="submitAddWechat" />
  </div>
</template>

<script>
// 引入logout方法
import { logOut } from "network/login.js";
import BasicInfo from "views/user/BasicInfo";
import TableHeader from "components/StudentList";
import AddWechat from "@/views/administrator/AddWechat.vue";
import RoleMenuItem from "./components/RoleMenuItem.vue";
import { AdminLoginByRolesId } from "network/projectLogin.js";

import {
  getRuleName,
  getAdminInfo,
  getWeiXinImageOpen,
  getWeiXinAdminImageOpen,
  GetAdultSystemKey,
} from "network/administrator";
import {
  getAdminWeiXinByAdminId,
  addAdminWeiXin,
  updateAdminWeiXin,
  getPersonalAssistantTypeList
} from "network/wechat.js";
import actions from '../../main.js';

export default {
  name: "Header",
  components: {
    BasicInfo,
    TableHeader,
    AddWechat,
    RoleMenuItem
  },
  data() {
    return {
      msg: "",
      maxRelationCount: "",
      userInfoData: {},
      addTypeList: [],
      dialogVisible: false, //资料设置弹窗
      passwordDialogVisible: false, //密码设置弹窗
      // roleName: "", // moved to computed for reactive sync with store/session
      // waitReadingCount: null, //待阅读消息
      name: "",
      dialogTitle: "",
      dialogVisibleImg: false,
      codeImg: "",
      loading: false,
      queryAdminId: null,
      emptyText: "暂无数据",
      tableLoading: false,
      loadingText: "loading...", //加载状态提示文本
      dialogVisibleWeichat: false,
      weichatHeaderData: [
        {
          label: "微信号",
          prop: "number",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "微信id",
          align: "center",
          prop: "weiXinId",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "是否企微",
          align: "center",
          prop: "isEnterprise",
          noSetText: "未设置",
          // noTooltip: true,
          custom: true,
        },
        {
          label: "是否启用",
          align: "center",
          prop: "isOpen",
          noSetText: "未设置",
          // noTooltip: true,
          custom: true,
        },
        {
          label: "自动加好友",
          align: "center",
          prop: "isAutoAddFriend",
          noSetText: "未设置",
          custom: true,
        },
        {
          label: "个微助手",
          align: "center",
          prop: "personalAssistantType",
          noSetText: "未设置",
          custom: true,
        },
        {
          label: "操作",
          align: "center",
          prop: "operate",
          custom: true,
        },
      ],
      weichatTableData: [],
      dialogVisibleEditWeichat: false,
      form: {
        number: "",
        weiXinId: "",
        isEnterprise: false,
        isOpen: false,
        isAutoAddFriend: false,
        personalAssistantType: null,
      },
      // 个微助手平台选项统一由后端枚举接口提供。
      personalAssistantTypeOptions: [],
      rules: {
        number: [
          { required: true, message: "请输入微信号", trigger: "blur" },
          { max: 50, message: "微信号不能超过50个字符", trigger: ["blur", "change"] },
        ],
        isEnterprise: [
          { required: true, message: "请选择是否企业微信", trigger: "blur" },
        ],
        isOpen: [{ required: true, message: "请选择是否启用", trigger: "blur" }],
        personalAssistantType: [{ required: true, message: "请选择个微助手平台", trigger: "change" }],
      },
      dialogVisibleAddWeichat: false,
      isLoading: false,
      isLoading2: false,
      isAdmin: false,
      wechatCount: 0,
      wechatNumber: '',
      canScrollProjectTabsLeft: false,
      canScrollProjectTabsRight: false,
      projectTabsResizeObserver: null,
      projectTabsAnimationFrame: null,
    };
  },
  watch: {
    //监听路由是否有管理员id
    "$route.query.adminId": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.queryAdminId = newVal;
        }
      },
      deep: true,
    },
    otherProjectsList: {
      handler() {
        this.$nextTick(this.scheduleProjectTabsScrollStateRefresh);
      },
      deep: true,
    },
    permissionId() {
      this.$nextTick(this.scheduleProjectTabsScrollStateRefresh);
    },
  },
  computed: {
    hasAutoAddFriendWechat() {
      return this.weichatTableData.some(item => item.isAutoAddFriend);
    },
    //临时授权id，大于0时不显示导航栏的项目切换及修改密码功能
    permissionId() {
      let adminCache = null;
      if (this.$store.state.AdminCache) {
        adminCache = this.$store.state.AdminCache;
      } else if (sessionStorage.getItem("AdminCache")) {
        adminCache = JSON.parse(sessionStorage.getItem("AdminCache"));
      }
      return adminCache?.permissionId;
    },
    user() {
      let data = this.$store.state.parameter.user
      return data
    },
    // 顶部项目与角色分组数据
    otherProjectsList() {
      let adminCache = null;
      if (this.$store.state.AdminCache) {
        adminCache = this.$store.state.AdminCache;
      } else if (sessionStorage.getItem("AdminCache")) {
        adminCache = JSON.parse(sessionStorage.getItem("AdminCache"));
      }
      if (!adminCache || !Array.isArray(adminCache.roles)) return [];
      const projectsMap = {};
      adminCache.roles.forEach(role => {
        const pname = role.projectName || '未分组';
        if (!projectsMap[pname]) {
          projectsMap[pname] = { projectName: pname, logoPath: role.logoPath || '', roles: [], project: role.project, };
        }
        projectsMap[pname].roles.push(role);
      });
      console.log(projectsMap, 'projectsMap')
      return Object.values(projectsMap);
    },

    teamAdminCount() {
      let adminCache = null;
      if (this.$store.state.AdminCache) {
        adminCache = this.$store.state.AdminCache;
      } else if (sessionStorage.getItem("AdminCache")) {
        adminCache = JSON.parse(sessionStorage.getItem("AdminCache"));
      }
      return adminCache?.teamAdminCount;
    },
    allConfig() {
      let config;
      if (this.$store.state.allConfig) {
        config = this.$store.state.allConfig;
      } else if (JSON.parse(sessionStorage.getItem("allConfig"))) {
        config = JSON.parse(sessionStorage.getItem("allConfig"));
      } else {
        config = {};
      }
      return config;
    },
    title() {
      return this.allConfig.projectName;
    },
    logoImageUrl() {
      let logoAdminImageUrl = "";
      if (this.$store.state.AdminCache?.roles) {
        logoAdminImageUrl = this.$store.state.AdminCache?.roles?.find(role => role.isLoginIn === true)?.logoPath;
      } else if (this.$store.state.AdminCache?.logoAdminImageUrl) {
        logoAdminImageUrl = this.$store.state.AdminCache?.logoAdminImageUrl;
      } else {
        logoAdminImageUrl = "";
      }
      return logoAdminImageUrl;
    },
    mobileUrl() {
      return this.allConfig.mobileAdress;
    },
    adminMobileUrl() {
      return this.allConfig.adminMobileSiteUrl;
    },
    pcUrl() {
      return this.allConfig.pcSiteUrl;
    },
    huiHangUniappDomain() {
      return this.allConfig.huiHangUniappDomain;
    },
    sbClientUniappDomain() {
      return this.allConfig.sbClientUniappDomain;
    },
    waitReadingCount() {
      if (this.$store.state.AdminCache) {
        return this.$store.state.AdminCache.waitReadingCount;
      } else if (sessionStorage.getItem("AdminCache")) {
        return JSON.parse(sessionStorage.getItem("AdminCache")).waitReadingCount;
      } else {
        return "";
      }
    },
    // 管理员id
    adminId() {
      if (
        this.$store.state &&
        this.$store.state.AdminCache &&
        this.$store.state.AdminCache.adminId
      ) {
        return this.$store.state.AdminCache.adminId;
      } else if (sessionStorage.getItem("AdminCache")) {
        return JSON.parse(sessionStorage.getItem("AdminCache")).adminId;
      } else {
        return this.queryAdminId;
      }
    },
    adminInfo() {
      if (
        (this.$store.state && this.$store.state.AdminCache) || sessionStorage.getItem("AdminCache")
      ) {
        return this.$store.state.AdminCache || JSON.parse(sessionStorage.getItem("AdminCache"));
      }
      return null;
    },
    adminLogo() {
      return this.adminInfo?.adminLogo || "";
    },
    adminName() {
      return this.adminInfo?.adminName || "";
    },
    // 添加计算属性获取用户角色名称，确保它能响应式更新
    userRoleName() {
      if (this.adminInfo && this.adminInfo.roleName) {
        return this.adminInfo.roleName;
      }
      return this.roleName || '';
    },
    // 当前角色名称（优先从 AdminRoleInfo 中以 isLoginIn 标识的角色获取）
    roleName() {
      // 优先从 AdminRoleInfo (包含多个角色) 中获取当前登录角色名称
      let roleName = "";
      if (this.$store.state.AdminCache?.roles) {
        roleName = this.$store.state.AdminCache?.roles?.find(role => role.isLoginIn === true)?.roleName;
      } else if (this.$store.state.AdminCache?.rolesName) {
        roleName = this.$store.state.AdminCache?.rolesName;
      } else {
        roleName = "";
      }
      return roleName;
    },
    // 添加计算属性获取用户姓名，确保它能响应式更新
    userName() {
      if (this.adminInfo && this.adminInfo.adminName) {
        return this.adminInfo.adminName;
      }
      return this.name || '';
    },
    educationProductUrl() {
      return this.adminInfo && this.adminInfo.educationProductUrl;
    },
  },

  mounted() {
    this.getPersonalAssistantTypeOptions();
    // 初始化用户信息
    this.updateUserInfo();
    var adminData = JSON.parse(sessionStorage.getItem("allConfig"));
    this.codeImg = adminData.weiXinImageUrl;
    this.initWechatStatus();
    this.$nextTick(() => {
      this.refreshProjectTabsScrollState();
      window.addEventListener("resize", this.scheduleProjectTabsScrollStateRefresh);
      if (window.ResizeObserver && this.$refs.projectTabsScroll) {
        this.projectTabsResizeObserver = new window.ResizeObserver(
          this.scheduleProjectTabsScrollStateRefresh
        );
        this.projectTabsResizeObserver.observe(this.$refs.projectTabsScroll);
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.scheduleProjectTabsScrollStateRefresh);
    if (this.projectTabsResizeObserver) {
      this.projectTabsResizeObserver.disconnect();
    }
    if (this.projectTabsAnimationFrame) {
      window.cancelAnimationFrame(this.projectTabsAnimationFrame);
    }
  },

  methods: {
    getPersonalAssistantTypeText(type) {
      const option = this.personalAssistantTypeOptions.find((item) => Number(item.key) === Number(type));
      return option ? option.value : '';
    },
    // 枚举接口按值排序，首项为关闭状态；标签样式不再依赖写死的枚举值。
    getPersonalAssistantTypeTagType(type) {
      const disabledOption = this.personalAssistantTypeOptions[0];
      return disabledOption && Number(disabledOption.key) === Number(type) ? 'info' : 'success';
    },
    // 获取个微助手平台枚举，供列表和编辑表单共用。
    async getPersonalAssistantTypeOptions() {
      try {
        const res = await getPersonalAssistantTypeList();
        this.personalAssistantTypeOptions = res && res.code == 1 ? (res.result || []) : [];
      } catch (error) {
        console.error('获取个微助手平台枚举失败:', error);
        this.personalAssistantTypeOptions = [];
      }
    },
    scheduleProjectTabsScrollStateRefresh() {
      if (this.projectTabsAnimationFrame) {
        window.cancelAnimationFrame(this.projectTabsAnimationFrame);
      }
      this.projectTabsAnimationFrame = window.requestAnimationFrame(() => {
        this.projectTabsAnimationFrame = null;
        this.refreshProjectTabsScrollState();
      });
    },
    refreshProjectTabsScrollState() {
      const scrollContainer = this.$refs.projectTabsScroll;
      if (!scrollContainer) return;

      const scrollShell = scrollContainer.parentElement;
      const hasOverflow = scrollContainer.scrollWidth > scrollShell.clientWidth + 1;
      const maxScrollLeft = Math.max(
        0,
        scrollContainer.scrollWidth - scrollContainer.clientWidth
      );

      this.canScrollProjectTabsLeft = hasOverflow && scrollContainer.scrollLeft > 1;
      this.canScrollProjectTabsRight =
        hasOverflow && scrollContainer.scrollLeft < maxScrollLeft - 1;
    },
    scrollProjectTabs(direction) {
      const scrollContainer = this.$refs.projectTabsScroll;
      if (!scrollContainer) return;

      const scrollDistance = Math.max(scrollContainer.clientWidth * 0.7, 240);
      scrollContainer.scrollTo({
        left: scrollContainer.scrollLeft + direction * scrollDistance,
        behavior: "smooth",
      });
    },
    // 更新用户信息到组件数据
    updateUserInfo() {
      // 使用计算属性更新组件数据
      this.name = this.userName;
    },
    async initWechatStatus() {
      const AdminCache = sessionStorage.getItem("AdminCache") && JSON.parse(sessionStorage.getItem("AdminCache"));
      if (!AdminCache || !AdminCache.adminId) {
        this.wechatCount = 0;
        this.wechatNumber = '';
        return;
      }
      const list = await this.fetchWechatList(AdminCache.adminId);
      if (list.length === 0) {
        this.wechatCount = 0;
        this.wechatNumber = '';
      } else if (list.length === 1) {
        this.wechatCount = 1;
        this.wechatNumber = list[0].number;
      } else {
        this.wechatCount = list.length;
        this.wechatNumber = '';
      }
    },
    async fetchWechatList(adminId) {
      const res = await getAdminWeiXinByAdminId(adminId);
      if (Array.isArray(res.data)) {
        return res.data;
      }
      if (Array.isArray(res.result)) {
        return res.result;
      }
      return [];
    },
    async handleWechatDropdown() {
      if (this.wechatCount === 0) {
        this.dialogVisibleAddWeichat = true;
        return;
      }
      const AdminCache = sessionStorage.getItem("AdminCache") && JSON.parse(sessionStorage.getItem("AdminCache"));
      if (!AdminCache || !AdminCache.adminId) {
        this.weichatTableData = [];
        this.dialogVisibleWeichat = true;
        return;
      }
      const list = await this.fetchWechatList(AdminCache.adminId);
      this.weichatTableData = list;
      this.dialogVisibleWeichat = true;
    },
    // 角色跳转：弹出选择窗口/当前窗口，并携带登录 key
    async navigateToRole(pcSiteUrl, role) {
      if (!pcSiteUrl || pcSiteUrl.toString().trim() === '') {
        this.$message.warning('该角色暂无PC端地址');
        return;
      }

      if (!role || !role.adminId) {
        this.$message.warning('管理员信息不存在');
        return;
      }

      try {
        this.$confirm(
          '请选择打开方式',
          '登录确认',
          {
            confirmButtonText: '新窗口打开',
            cancelButtonText: '当前窗口打开',
            type: 'warning',
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            showClose: true,
          }
        )
          .then(async () => {
            const res = await AdminLoginByRolesId({
              rolesId: role.roleId,
              loginType: 2,
              adminId: role.adminId,
              isLinkAdminId: role.isLinkAdminId,
            });
            if (res.code == 1) {
              const targetUrl = `${pcSiteUrl}?key=${res.result}`;
              window.open(targetUrl, '_blank');
            } else {
              this.$alert(res.message || '角色登录失败');
            }
          })
          .catch(async (action) => {
            // 取消：当前窗口打开；关闭对话框则不处理
            if (action === 'cancel') {
              const res = await AdminLoginByRolesId({
                rolesId: role.roleId,
                loginType: 2,
                adminId: role.adminId,
                isLinkAdminId: role.isLinkAdminId,
              });
              if (res.code == 1) {
                const targetUrl = `${pcSiteUrl}?key=${res.result}`;
                window.location.replace(targetUrl);
              } else {
                this.$alert(res.message || '角色登录失败');
              }
            }
          });
      } catch (error) {
        console.error('角色跳转失败:', error);
        this.$message.error('角色跳转失败，请重试');
      }
    },

    // 打开成人类系统
    openAdultSystem() {
      const { adminTel: tel, adminName: name, adminId: id } = this.adminInfo;
      GetAdultSystemKey({ tel, name, id })
        .then((res) => {
          if (res.data.IsSuccess && this.educationProductUrl) {
            window.open(`${this.educationProductUrl}?key=${res.data.Results}`, "_blank");
          } else {
            this.$message({
              message: "未获取到成人类系统地址",
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "未获取到成人类系统地址",
            type: "warning",
          });
        });
    },
    addWechat() {
      this.dialogVisibleAddWeichat = true;
    },
    handleAutoAddFriendChange(value) {
      if (!value) return;
      const alreadyConfigured = this.weichatTableData.some(item =>
        item.isAutoAddFriend && item.id !== this.form.id
      );
      if (alreadyConfigured) {
        this.form.isAutoAddFriend = false;
        this.$message.warning("同一个老师有且只能设置一个自动添加好友的微信号");
      }
    },
    async submitAddWechat(form) {
      this.isLoading2 = true;
      const AdminCache = sessionStorage.getItem("AdminCache") && JSON.parse(sessionStorage.getItem("AdminCache"));
      const params = { ...form };
      const res = await addAdminWeiXin(params);
      this.isLoading2 = false;
      // 优先判断 res.code == 1，其次 res.data.code == 1
      const success = (res && res.code === 1) || (res.data && res.data.code === 1);
      if (!success) {
        this.$alert((res.data?.message || res.message || '添加失败'), "提示", {
          confirmButtonText: "确定",
          callback: (action) => { },
        });
        return;
      }
      this.$alert((res.data?.message || res.message || '添加成功'), "提示", {
        confirmButtonText: "确定",
        callback: async (action) => {
          this.$refs.addWechat.resetFormFields();
          this.dialogVisibleAddWeichat = false;
          this.weichatTableData = await this.fetchWechatList(AdminCache.adminId);
          this.dialogVisibleWeichat = true;
          this.initWechatStatus(); // 添加后刷新微信号状态
        },
      });

      // this.updataList()
    },
    closeDialog1() {
      this.dialogVisibleAddWeichat = false;
    },
    async editSubmitWechat() {
      if (this.isLoading) {
        return false;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.submitWechat();
        }
      });
    },
    async submitWechat() {
      this.isLoading = true;
      // 只提交需要的字段
      const AdminCache = sessionStorage.getItem("AdminCache") && JSON.parse(sessionStorage.getItem("AdminCache"));
      const editData = {
        id: this.form.id,
        adminId: AdminCache.adminId,
        number: this.form.number,
        isEnterprise: this.form.isEnterprise,
        isOpen: this.form.isOpen,
        isAutoAddFriend: !!this.form.isAutoAddFriend,
        personalAssistantType: this.form.personalAssistantType
      };
      const res = await updateAdminWeiXin(editData);
      this.isLoading = false;
      const success = (res && res.code === 1) || (res.data && res.data.code === 1);
      if (!success) {
        this.$alert((res.data?.message || res.message || '编辑失败'), "提示", {
          confirmButtonText: "确定",
          callback: (action) => { },
        });
        return;
      }
      this.$alert((res.data?.message || res.message || '编辑成功'), "提示", {
        confirmButtonText: "确定",
        callback: async (action) => {
          const list = await this.fetchWechatList(AdminCache.adminId);
          this.weichatTableData = list;
          this.dialogVisibleEditWeichat = false;
          this.dialogVisibleWeichat = true;
          this.initWechatStatus(); // 编辑后刷新微信号状态
        },
      });
    },
    async openEditWechat(row) {
      // 直接用 row 数据，不再请求旧接口
      this.form = {
        id: row.id,
        ...row,
      };
      delete this.form.adminName;
      this.dialogVisibleEditWeichat = true;
    },
    async openWeichatNumber() {
      const AdminCache =
        sessionStorage.getItem("AdminCache") &&
        JSON.parse(sessionStorage.getItem("AdminCache"));
      const res = await GetAdminWeiXinByAdminId(AdminCache.adminId);
      if (!res.code) {
        if (res.message == "暂无数据") {
          this.$message.error("当前登录老师没有添加微信号");
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
          });
        }
        return;
      }
      this.weichatTableData = res.result;
      this.dialogVisibleWeichat = true;
    },
    beforeClose() {
      this.dialogVisibleWeichat = false;
      // this.dialogVisibleEditWeichat = false
    },
    addTab() {
      const theMenuChilds = sessionStorage.getItem("theMenuChilds")
        ? JSON.parse(sessionStorage.getItem("theMenuChilds"))
        : [];
      const obj = {
        component: "SystemMessage",
        name: "221",
        title: "我的系统消息",
        index: "",
      };
      theMenuChilds.forEach((item) => {
        if (item.componentName === "SystemMessage") {
          obj.name = item.id;
          obj.index = item.id;
          (obj.id = item.id), (item.title = "我的系统消息");
        } else {
          item.childs.forEach((item) => {
            if (item.componentName === "SystemMessage") {
              obj.name = item.id;
              obj.index = item.id;
              obj.id = item.id;
            }
          });
        }
      });
      obj.index = obj.index.toString();
      sessionStorage.setItem("tabObj", JSON.stringify(obj));
      this.$emit("add-tab", obj);
    },
    clientClick() {
      let tabObj = {
        component: "AllClient",
        title: "客户端",
        id: 14343,
        index: '14343',
        name: '14343',
      };
      sessionStorage.setItem("tabObj", JSON.stringify(tabObj));
      this.$emit("add-tab", tabObj);
    },
    SendMessage() {
      var user = "123";
      var message = "123";
      var msgObj = {
        user: user,
        msg: message,
        proxy: { address: "http://www.baidu.com", port: 90 },
      };
      //SendMessage和后台方法对应
      this.signalr.invoke("SendMessageExt", msgObj).catch(function (err) {
        console.error(err.toString());
      });
    },
    // 收藏
    collectClick() {
      this.$message({
        message: "您的浏览器不支持，请按 Ctrl+D 手动收藏！",
        type: "warning",
      });
    },
    // 退出登录
    logoutClick() {
      const defaultUrl = 'https://sb.hbzsb.cn/';
      let sessionCache = null;
      sessionCache = JSON.parse(sessionStorage.getItem('AdminCache'));
      const rawUrl = sessionCache?.centerAdminUrl || defaultUrl;
      const centerAdminUrl = rawUrl?.trim() || defaultUrl;
      sessionStorage.clear();
      const logoutUrl = `${centerAdminUrl}?logOut=true`;
      window.location.replace(logoutUrl);
      // logOut();
    },
    closeDialog(val) {
      if (!val) {
        this.dialogVisible = false;
        this.passwordDialogVisible = false;
        this.dialogVisibleAdmin = false;
        this.dialogVisibleStudent = false;
      }
      if (val == true) {
        this.dialogVisible = false;
        this.passwordDialogVisible = false;
        this.dialogVisibleAdmin = false;
        this.dialogVisibleStudent = false;
        var exit;
        clearTimeout(exit);
        exit = setTimeout(function () {
          logOut();
        }, 1000);
      }
      if (val == false) {
        this.dialogVisible = false;
        this.passwordDialogVisible = false;
        this.dialogVisibleAdmin = false;
        this.dialogVisibleStudent = false;
        //  关闭资料设置弹窗请求管理员信息
        // this.getUserInfoData(this.adminId);
      }
    },
    setPassWord() {
      this.passwordDialogVisible = true;
    },
    // 资料设置
    async dataSet() {
      const result = await getRuleName();
      const res = await getAdminInfo(this.adminId);
      if (res && res.code == 1) {
        this.userInfoData = res.result;
      } else {
        if (res.message) {
          this.$alert(res.message);
        }
      }

      if (result && result.code == 1) {
        this.addTypeList = result.result;
        this.addTypeList.unshift({
          key: 0,
          value: "请选择",
        });
        this.dialogVisible = true;
      } else {
        if (result.message) {
          this.$alert(result.message);
        }
      }
    },

    openImgDialog(type) {
      if (type == "admin") {
        // 打开管理员公众号
        // this.dialogTitle = "关注微信公众号可实时接收系统消息";
        this.dialogTitle = "关注老师（管理员）微信公众号可实时接收系统消息";
        this.dialogVisibleImg = true;
        this.isAdmin = true;
        this.WeiXinImageOpen(this.adminId);
      }
      if (type == "adminBrCode") {
        this.dialogTitle = "关注老师（管理员）微信公众号可实时接收系统消息";
        this.dialogVisibleImg = true;
        this.isAdmin = true;
        this.WeiXinAdminImageOpen(this.adminId);
      }
      if (type == "student") {
        // 打开学员微信公众号
        this.dialogTitle = "学员微信公众号二维码图片";
        this.dialogVisibleImg = true;
        var studentUrl = this.$store.state.allConfig.weiXinImageUrl;
        this.codeImg = studentUrl + "?adminId =" + this.adminId;
        this.isAdmin = false;
      }

      if (type == "program") {
        // 打开微信小程序
        this.dialogTitle = "慧航微信小程序";
        this.dialogVisibleImg = true;
        this.codeImg = this.$store.state.allConfig.weChatAppletImageUrl;
        this.isAdmin = false;
      }
      if (type == "workProgram") {
        // 作业助手
        this.dialogTitle = "作业助手微信小程序";
        this.dialogVisibleImg = true;
        this.codeImg =
          "https://appfile2.sbgw.cn/hhxt/8f7657044211446f99664396398a718c.jpg";
        this.isAdmin = false;
      }
    },
    // 鼠标移入图标高亮
    enterBlock(event, classnName) {
      event.currentTarget.firstElementChild.classList.remove(classnName);
      event.currentTarget.firstElementChild.classList.add(classnName + "2");
    },
    leaveBlock(event, classnName) {
      event.currentTarget.firstElementChild.classList.remove(classnName + "2");
      event.currentTarget.firstElementChild.classList.add(classnName);
    },
    async WeiXinImageOpen(id) {
      this.loading = true;
      this.codeImg = "";
      const res = await getWeiXinImageOpen(id);
      this.loading = false;
      this.codeImg = "data:image/png;base64," + res;
      this.codeImg = window.URL.createObjectURL(res);
    },
    async WeiXinAdminImageOpen(id) {
      this.loading = true;
      this.codeImg = "";
      const res = await getWeiXinAdminImageOpen(id);
      this.loading = false;
      this.codeImg = "data:image/png;base64," + res;
      this.codeImg = window.URL.createObjectURL(res);
    },
  },
};
</script>

<style lang="scss">
.red {
  color: red !important;
  margin-top: 10px;
}

.el-dialog__header {
  padding: 15px !important;
}

/* 头部 */
.divided2 {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin: 5px 0;
}

.header-wrapper {
  height: 47px;
  line-height: 47px;
  background-color: var(--HeadBgColor, "#409EFF") !important;
  color: var(--HeadTextColor, "#fff") !important;
  overflow: hidden;
}

/* logo部分 */
.header-left {
  font-size: 18px;
  font-weight: bold;
  background-color: var(--HeadBgColor, "#409EFF") !important;
  width: 180px;
  float: left;
  padding-left: 22px;
}

.header-left a {
  color: var(--HeadTextColor, "#fff") !important;
}

.logo {
  width: 80%;
  height: auto;
  margin-top: -2px;
  margin-right: 4px;
}

.header-right {
  /* padding: 0 15px; */
  margin-right: 18px;
  display: flex;
  align-items: center;
  height: 47px;
  justify-content: space-between;
}

.role-name {
  color: var(--ThemeColor, "#333");
  border: 1px solid var(--ThemeColor, "#333");
  border-radius: 99px;
  display: inline-flex;
  align-items: center;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
  margin-right: 12px;
  background: #fff;
  font-size: 13px;
  flex-shrink: 0;
  white-space: nowrap;
}

.btn-collect {
  margin-right: 15px;
  cursor: pointer;
  display: inline-block;
  position: relative;
  color: var(--HeadTextColor, "#fff") !important;
}

.btn-collect i,
.custom-dropdown i.el-icon-user {
  margin-right: 4px;
}

.btn-collect::after {
  margin-left: 15px;
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 1px;
  height: 18px;
  background-color: rgba(255, 255, 255, 0.7);
  margin-top: -2px;
}

.custom-dropdown {
  text-align: center;
  cursor: pointer;
  color: var(--HeadTextColor, "#fd5252") !important;
}

.custom-dropdown-list {
  min-width: 180px;
  text-align: center;
}

.item-btn {
  display: block;
}

.img {
  text-align: center;
}

.img img {
  height: 250px;
}

.dialogprop ::v-deep .el-dialog__body {
  margin-top: -15px;
}

.waitReadingCount {
  font-size: 12px;
  position: absolute;
  right: 10px;
  top: 6px;
  line-height: 14px;
  border-radius: 40px;
  padding: 0 3px;
}

.wechat-table-toolbar {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.wechat-add-btn {
  height: 42px;
  padding: 0 22px;
  font-size: 16px;
}

.wechat-auto-add-field {
  display: block;
}

.wechat-auto-add-tip {
  display: block;
  max-width: 360px;
  margin-top: 10px;
  font-size: 12px;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
}

.personal-assistant-tip {
  display: block;
  max-width: 520px;
  margin-top: 8px;
  font-size: 12px;
  line-height: 20px;
  white-space: normal;
  color: #f56c6c;
}

.personal-assistant-options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.weChat-official-account {
  width: 17px;
  height: 17px;
  display: inline-block;
  vertical-align: middle;
  margin: auto;
  background: url("../../assets/images/official_account.png") no-repeat;
  background-size: 17px auto;
}

.weChat-official-account2 {
  width: 17px;
  height: 17px;
  display: inline-block;
  vertical-align: middle;
  margin: auto;
  background: url("../../assets/images/official_account2.png") no-repeat;
  background-size: 17px auto;
}

.mini-program {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
  margin: auto;
  background: url("../../assets/images/mini_program.png") no-repeat;
  background-size: 15px auto;
}

.mini-program2 {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
  margin: auto;
  background: url("../../assets/images/mini_program2.png") no-repeat;
  background-size: 15px auto;
}

/* 顶部项目导航：内容超过 1300px（或当前可用宽度）时通过两侧箭头滚动 */
.project-tabs-scroll-shell {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  min-width: 0;
  max-width: 1300px;
  height: 47px;
  margin-right: auto;
  margin-left: 50px;
  overflow: hidden;
}

.project-tabs-container {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 10px;
  min-width: 0;
  height: 47px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  scroll-behavior: smooth;
}

.project-tabs-container::-webkit-scrollbar {
  display: none;
}

.project-tabs-scroll-button {
  width: 28px;
  height: 47px;
  padding: 0;
  border: 0;
  outline: none;
  color: var(--HeadTextColor, "#fff") !important;
  background: var(--HeadBgColor, "#409EFF");
  cursor: pointer;
  flex: 0 0 28px;
  font-size: 15px;
  line-height: 47px;
  text-align: center;
}

.project-tabs-scroll-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 右侧操作区不被压缩 */
.header-right>.fr {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.project-tab {
  /* margin-right: 30px; */
  cursor: pointer;
  flex: 0 0 auto;
}

.project-tab-title {
  height: 45px;
  line-height: 45px;
  color: var(--HeadTextColor, "#fff") !important;
  gap: 6px;
  padding: 0 8px;
  font-size: 15px;
  padding-right: 30px;
  white-space: nowrap;
}

.project-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 4px;
}

.project-name {
  font-weight: 600;
  color: var(--HeadTextColor, "#fff") !important;
}

.project-arrow {
  font-size: 15px;
  color: var(--HeadTextColor, "#fff") !important;
}

.project-dropdown-menu {
  min-width: 160px;
}

/* .project-dropdown-menu.project-dropdown-menu--menu {
  width: 260px;
  box-sizing: border-box;
} */
.project-dropdown-menu .project-role-menu,
.project-dropdown-menu .project-role-menu .el-menu,
.project-dropdown-menu .project-role-menu .el-submenu,
.project-dropdown-menu .project-role-menu .el-menu-item {
  width: 100%;
  box-sizing: border-box;
}

.role-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
}

.role-item-icon {
  margin-right: 8px;
  font-size: 14px;
  color: #000;
  display: inline-flex;
  align-items: center;
}

.disabled-role {
  cursor: not-allowed;
  color: #999;
}

.current-role-tag {
  margin-left: auto;
}

.header-wechat-table-dialog {
  .el-dialog__body {
    padding: 0px 20px 30px;
  }

  /* 防止继承 header 的 47px 行高导致表头/行高异常 */
  .el-table th,
  .el-table td,
  .el-table .cell {
    line-height: 32px;
  }

  .el-table th,
  .el-table td {
    padding: 10px 0;
  }
}

.wechatEdit {
  .button {
    padding-left: 120px;
  }
}

.el-dropdown,
.el-dropdown * {
  outline: none !important;
}

.project-role-menu {
  max-height: 500px;
  overflow: auto;
}

/* el-menu 被包在 dropdown-menu 的 li 内，去掉 li 的 hover/点击样式 */
.project-dropdown-menu__wrap {
  padding: 0 !important;
  height: auto !important;
  line-height: normal !important;
  background: transparent !important;
  cursor: default !important;
}

.project-dropdown-menu__wrap:hover {
  background: transparent !important;
}

.user-logo {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 6px;
  object-fit: cover;
}
</style>
